import React, { Fragment } from 'react';

import { MatchListType } from 'app-constants';
import matchList from 'modules/match-list';
import promo from 'modules/promo';
import useUpcoming from './useUpcoming';

const {
    components: { MatchListContainer },
} = matchList;
const {
    components: { MobileTopMatchList },
} = promo;

const Upcoming: React.FC = () => {
    const {
        fetchStatus,
        shouldRenderMobileTopMatches,
        pollerOpts,
    } = useUpcoming();

    return (
        <Fragment>
            {shouldRenderMobileTopMatches ? (
                <MobileTopMatchList />
            ) : (
                <MatchListContainer
                    type={MatchListType.UPCOMING}
                    fetchStatus={fetchStatus}
                    pollerOpts={pollerOpts}
                />
            )}
        </Fragment>
    );
};

export default Upcoming;
